/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Per_MinuteInputs */



/**
* | output |
* | --- |
* | "$1.00/minute" |
*
* @param {Signup_Compare_Per_MinuteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_per_minute = /** @type {((inputs?: Signup_Compare_Per_MinuteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Per_MinuteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "de") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "it") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "ru") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "es") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "ja") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "hi") return /** @type {LocalizedString} */ ("$1.00/minute")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("$1.00/minute")
	return /** @type {LocalizedString} */ ("$1.00/minute")
});